import React from 'react';

const ChannelSelectNoOptions = () => {
  return (
    <div role="alert" className="ChannelSelector__noChannels">
      <span>0 channels found</span>
    </div>
  );
};

export default ChannelSelectNoOptions;
